<template>
  <div class="section section--light" id="booking">
    <div class="section-text">
      <h3>{{ $t("booking.title") }}</h3>
      {{ $t("booking.body") }}
    </div>
  </div>
</template>
